import { LocationGroupFilter } from "planning-portal-library/src/lib/core/domain/models/location-group-filter";
import { LocationGroupFilterWebEntity } from "./location-group-filter-web-entity";
import { Mapper } from "planning-portal-library/src/lib/core/base";
import { FilterConditionWebEntityMapper } from "./filter-condition-mapper";

export class FilterSchemaWebRepositoryMapper extends Mapper<
  LocationGroupFilterWebEntity,
  LocationGroupFilter
> {
  mapFrom(param: LocationGroupFilterWebEntity): LocationGroupFilter {


 const filterConditionMapper = new FilterConditionWebEntityMapper();   

    var condition = filterConditionMapper.mapFrom(param.condition);
    return {
      id: param.id,
      name: param.name,
      condition: condition,      
      values:param.values,
      sequenceNumber: param.sequenceNumber   
    };
  }

  mapTo(param: LocationGroupFilter): LocationGroupFilterWebEntity {
    
 const filterConditionMapper = new FilterConditionWebEntityMapper();  

     var condition = filterConditionMapper.mapTo(param.condition); 
    return {
      id: param.id,
      name: param.name,
      condition: condition, 
      values:param.values,
      sequenceNumber: param.sequenceNumber     
    };
  }
}